import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FormStencilsService {
  constructor(private http: HttpClient) {}

  // TODO: Define Stencil model, refactor and extend FormConfig (form-config.model.ts)
  public get(includeSystem: boolean = false): Observable<any> {
    const url = `assets/data/form-stencils/form-stencil.data.json?timestamp=${new Date().getTime()}`;
    return this.http.get<any>(url).pipe(
      map((res: any[]) => {
        if (includeSystem) {
          return res.map((stencils) => stencils);
        }
        return res.filter((stencil) => !stencil.system);
      }),
    );
  }
}
